fragment ExploreMoreFragment on exploreMore_Entry {
  typeHandle
  heading
  exploreMoreCards {
    ... on exploreMoreCardsBlock_Entry {
      textOverlay
      image {
        url
        title
      }
      alt
      linkTarget {
        uri
      }
    }
  }
}
